import React, { useEffect, useRef } from 'react';
import { OrgChart } from 'd3-org-chart';
import { buildApiUrl, API_ENDPOINTS, authenticatedFetch } from '../config/api';

const TrainingTree = ({ memberId, siteId }) => {
  const chartContainer = useRef(null);

  useEffect(() => {
    async function fetchTrainingData() {
      try {
        const apiUrl = buildApiUrl(API_ENDPOINTS.SITE_MEMBER(siteId, memberId));
        const response = await authenticatedFetch(apiUrl);
        
        if (!response.ok) {
          throw new Error('Error al obtener los datos del miembro');
        }
        
        const memberData = await response.json();

      if (!memberData.training) {
        memberData.training = {};
      }

      const children = [];
      Object.keys(memberData.training).forEach((key) => {
          const training = memberData.training[key];
          children.push({
            id: `trainer-${key}`,
            name: training.trainer_name,
            startDate: training.start_date,
            endDate: training.end_date || 'Present',
          });
      });
      // Preparar los datos
      const chartData = [
        {
          id: memberData.id,
          name: memberData.name,
          photo: memberData.photo,
          contact: memberData.contact_info,
          role: memberData.role,
          children: children
        },
      ];

      // Crear el gráfico
      const chart = new OrgChart()
        .container(chartContainer.current)
        .data(chartData)
        .nodeWidth((d) => 250)
        .nodeHeight((d) => 150)
        .childrenMargin((d) => 40)
        .compactMarginBetween((d) => 15)
        .compactMarginPair((d) => 80)
        .nodeContent((d) => `
          <div style="padding: 10px; border: 1px solid #ccc; border-radius: 5px; background: #fff;">
            <img src="${d.data.photo}" alt="${d.data.name}" style="width: 50px; height: 50px; border-radius: 50%;">
            <div><strong>${d.data.name}</strong></div>
            <div>${d.data.role}</div>
            <div>${d.data.contact}</div>
          </div>
        `);

      chart.render();
      } catch (error) {
        console.error('Error fetching training data:', error);
        // Mostrar mensaje de error en el contenedor
        if (chartContainer.current) {
          chartContainer.current.innerHTML = `
            <div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #ef4444; font-size: 1.1rem;">
              <div style="text-align: center;">
                <div style="font-size: 2rem; margin-bottom: 1rem;">⚠️</div>
                <div>Error al cargar el árbol de entrenamiento</div>
                <div style="font-size: 0.9rem; margin-top: 0.5rem; color: #6b7280;">${error.message}</div>
              </div>
            </div>
          `;
        }
      }
    }

    fetchTrainingData();
  }, [memberId, siteId]);

  return <div ref={chartContainer} style={{ height: '600px', width: '100%' }} />;
};

export default TrainingTree;
